import { AxiosError } from 'axios';
import { AppOrganization } from '../appOrganization/types';

export enum SamlTypes {
    SAML_REQUEST = '@SamlTypes/SAML_REQUEST',
    SAML_SUCCESS = '@SamlTypes/SAML_SUCCESS',
    SAML_FAILURE = '@SamlTypes/SAML_FAILURE',
}

export interface Saml {
    appOrganization: AppOrganization;
    applicationId: number;
    orgId: number;
    callback: string;
    url: string;
}

export interface SamlState {
    data: Saml;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    success: boolean;
}
